

import React from 'react';

import App from './App';
import Trade from './Trade';
import Terms from './Terms';
import Successful from './Successful';
import { BrowserRouter, Routes, Route } from 'react-router-dom';


function IndexApp() {
    return (
        <div>
            
          
        
                
                <BrowserRouter>
                <Routes>
                <Route path="/" element={<App />} />
                <Route path="/trade" element={<Trade />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/trade/successful" element={<Successful />} />
                
               </Routes> 
               </BrowserRouter> 
                
            
            
          
        </div>
    )
}

export default IndexApp;
